<template>
    <div>
        <!-- Data Table -->
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Chassis Number</th>
                        <th>Make</th>
                        <th>Model</th>
                        <th>Year</th>
                        <th>Class</th>
                        <th>CO₂ 3PWLTP</th>
                        <th>CO₂ Difference (2025)</th>
                        <th>Industry Code</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td colspan="7" class="text-center">Loading...</td>
                    </tr>
                    <tr v-else-if="!emissions.data || emissions.data.length === 0">
                        <td colspan="7" class="text-center">No emissions data found</td>
                    </tr>
                    <tr v-else 
                        v-for="emission in emissions.data" 
                        :key="emission.id" 
                        @click="$emit('row-click', emission)"
                        class="clickable-row"
                    >
                        <td>{{ emission.chassis_number }}</td>
                        <td>{{ emission.make }}</td>
                        <td>{{ emission.model }}</td>
                        <td>{{ emission.year }}</td>
                        <td>{{ emission.class }}</td>
                        <td>{{ emission.co2_3pwltp }}</td>
                        <td>{{ emission.co2_difference_2025 }}</td>
                        <td>{{ emission.industry_code }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <nav v-if="emissions.last_page > 1">
            <ul class="pagination">
                <li class="page-item" :class="{ disabled: emissions.current_page <= 1 }">
                    <a class="page-link" @click="changePage(emissions.current_page - 1)">Previous</a>
                </li>
                <li 
                    v-for="page in visiblePages" 
                    :key="page"
                    class="page-item" 
                    :class="{ active: page === emissions.current_page }"
                >
                    <a class="page-link" @click="changePage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: emissions.current_page >= emissions.last_page }">
                    <a class="page-link" @click="changePage(emissions.current_page + 1)">Next</a>
                </li>
            </ul>
        </nav>

    </div>
</template>

<script>
export default {
    name: 'DataTable',
    props: {
        emissions: {
            type: Object,
            required: true,
            default: () => ({
                data: [],
                current_page: 1,
                last_page: 1,
                per_page: 50,
                total: 0
            })
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    emits: ['page-change', 'row-click'],
    computed: {
        visiblePages() {
            const current = this.emissions.current_page
            const last = this.emissions.last_page
            const delta = 2
            const range = []
            
            for (let i = Math.max(2, current - delta); i <= Math.min(last - 1, current + delta); i++) {
                range.push(i)
            }
            
            if (current - delta > 2) {
                range.unshift('...')
            }
            if (current + delta < last - 1) {
                range.push('...')
            }
            
            range.unshift(1)
            if (last !== 1) {
                range.push(last)
            }
            
            return range.filter((item, index, array) => array.indexOf(item) === index)
        }
    },
    methods: {
        changePage(page) {
            if (page >= 1 && page <= this.emissions.last_page && page !== this.emissions.current_page) {
                this.$emit('page-change', page)
            }
        }
    }
}
</script>

<style scoped>
.table th {
    background-color: #f8f9fa;
}

.pagination .page-link {
    cursor: pointer;
}

.pagination .page-item.disabled .page-link {
    cursor: not-allowed;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa;
}
</style> 


// WEBPACK FOOTER //
// resources/js/components/Co2Emissions/DataTable.vue